import { IcoArrowUpRight16 } from '@onefootprint/icons';
import Button from '../button';
import type { CtaProps } from './cta.types';

type CtaButtonProps = {
  cta: CtaProps;
  variant?: 'secondary';
  isLoading?: boolean;
};

export const CtaButton = ({ cta, variant, isLoading }: CtaButtonProps) => {
  if (cta.type === 'link') {
    return (
      <Button
        href={cta.href}
        target={cta.target}
        onClick={cta.onClick}
        loading={isLoading}
        variant={variant}
        fullWidth
        size="large"
        // A button that opens a new tab should read as one.
        suffixIcon={cta.target === '_blank' ? IcoArrowUpRight16 : undefined}
      >
        {cta.text}
      </Button>
    );
  }

  return (
    <Button
      type={cta.type}
      onClick={cta.onClick}
      loading={isLoading}
      variant={variant}
      fullWidth
      size="large"
      form={cta.type === 'submit' ? cta.form : undefined}
    >
      {cta.text}
    </Button>
  );
};
